(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Glossar_Neu"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const sectionElement = document.querySelector('[data-section-id="{{ section.id }}"]');
  if (!sectionElement) return;

  // Smooth scrolling for navigation links
  const navLinks = sectionElement.querySelectorAll('.glossary-nav__link');
  navLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const targetId = link.getAttribute('href');
      const targetElement = sectionElement.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
         // Optional: Highlight target briefly
         targetElement.style.transition = 'background-color 0.5s ease';
         // Use the letter background color for highlight, slightly transparent
         const letterBgColor = getComputedStyle(targetElement.querySelector('.glossary-letter-group__title')).backgroundColor;
         targetElement.style.backgroundColor = letterBgColor.replace(')', ', 0.2)').replace('rgb', 'rgba'); // Make it transparent
         setTimeout(() => {
           targetElement.style.backgroundColor = '';
         }, 1000); // Remove highlight after 1 second
      }
    });
  });

  // Reveal on Scroll for Banner (if enabled)
  const banner = sectionElement.querySelector('.reveal-on-scroll');
  if (banner && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // Optional: stop observing once visible
        }
      });
    }, { threshold: 0.1 }); // Trigger when 10% is visible

    observer.observe(banner);
  } else if (banner) {
     // Fallback for older browsers
     banner.classList.add('is-visible');
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casida-club-meditation"] && !Shopify.designMode) return;
  try {
    
class CasidaClubMeditation {
  constructor(container) {
    this.container = container; this.sectionId = container.dataset.sectionId;
    this.animationFrameId = null; this.state = 'idle'; this.isFinishing = false;
    this.phaseStartTime = 0; this.currentCycle = 0;
    this.totalSessionTime = 0; this.sessionTimerInterval = null;

    this.initElements(); this.initSettings();
    this.loadSettingsFromStorage(); this.addEventListeners();
    this.updateUI(); this.checkInitialMotionPreference();
  }

  initElements() {
    this.els = {
      circle: this.container.querySelector('.ccm-circle'),
      phaseText: this.container.querySelector('.ccm-phase-text'),
      countdown: this.container.querySelector('.ccm-countdown'),
      startButton: this.container.querySelector('.ccm-button-start'),
      resetButton: this.container.querySelector('.ccm-button-reset'),
      patternSelect: this.container.querySelector(`#ccm-pattern-${this.sectionId}`),
      patternInfoContainers: this.container.querySelectorAll('[data-pattern-info]'),
      customPatternInputs: this.container.querySelector(`#ccm-custom-pattern-inputs-${this.sectionId}`),
      customInhale: this.container.querySelector(`#ccm-custom-inhale-${this.sectionId}`),
      customHold: this.container.querySelector(`#ccm-custom-hold-${this.sectionId}`),
      customExhale: this.container.querySelector(`#ccm-custom-exhale-${this.sectionId}`),
      customHoldPost: this.container.querySelector(`#ccm-custom-hold-post-${this.sectionId}`),
      sessionTypeSelect: this.container.querySelector(`#ccm-session-type-${this.sectionId}`),
      sessionValueInput: this.container.querySelector(`#ccm-session-value-${this.sectionId}`),
      audioToggle: this.container.querySelector(`#ccm-audio-toggle-${this.sectionId}`),
      motionToggle: this.container.querySelector(`#ccm-motion-toggle-${this.sectionId}`),
      cycleCounter: this.container.querySelector('.ccm-cycle-counter'),
      sessionTimer: this.container.querySelector('.ccm-session-timer'),
      ariaLive: this.container.querySelector('.ccm-aria-live'),
    };
  }

  initSettings() { const data = JSON.parse(document.getElementById(`Shopify-section-settings-casida-club-meditation-${this.sectionId}`).textContent); this.settings = { ...data }; this.audioElement = this.getAudioElement(); }
  getAudioElement() { if (this.settings.audio_cue) { try { const audio = new Audio(this.settings.audio_cue); audio.preload = 'auto'; return audio; } catch (e) { console.error("Audio error:", e); return null; } } return null; }

  addEventListeners() {
    this.els.startButton.addEventListener('click', () => this.handleStartPause());
    this.els.resetButton.addEventListener('click', () => this.reset());
    this.els.patternSelect.addEventListener('change', () => this.handlePatternChange());
    [this.els.customInhale, this.els.customHold, this.els.customExhale, this.els.customHoldPost].forEach(el => el.addEventListener('change', () => this.handleSettingChange()));
    this.els.sessionTypeSelect.addEventListener('change', () => this.handleSessionTypeChange());
    this.els.sessionValueInput.addEventListener('change', () => this.handleSettingChange());
    if (this.els.audioToggle) this.els.audioToggle.addEventListener('change', () => this.handleSettingChange());
    if (this.els.motionToggle) this.els.motionToggle.addEventListener('change', () => this.handleMotionToggle());
    document.addEventListener('keydown', (e) => this.handleKeyPress(e));
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => this.handleMotionPreferenceChange(e.matches));
  }
  loadSettingsFromStorage() { const saved = localStorage.getItem(`casida-meditation-settings-${this.sectionId}`); if (saved) { const s = JSON.parse(saved); this.els.patternSelect.value = s.pattern; this.els.customInhale.value = s.customInhale || this.settings.custom_inhale; this.els.customHold.value = s.customHold || this.settings.custom_hold; this.els.customExhale.value = s.customExhale || this.settings.custom_exhale; this.els.customHoldPost.value = s.customHoldPost || this.settings.custom_hold_post_exhale; this.els.sessionTypeSelect.value = s.sessionType; this.els.sessionValueInput.value = s.sessionValue; if(this.els.audioToggle) this.els.audioToggle.checked = s.audioOn; if(this.els.motionToggle) this.els.motionToggle.checked = s.motionReduced; } this.handlePatternChange(); this.handleSessionTypeChange(); this.handleMotionToggle(); }
  saveSettingsToStorage() { const s = { pattern: this.els.patternSelect.value, customInhale: this.els.customInhale.value, customHold: this.els.customHold.value, customExhale: this.els.customExhale.value, customHoldPost: this.els.customHoldPost.value, sessionType: this.els.sessionTypeSelect.value, sessionValue: this.els.sessionValueInput.value, audioOn: this.els.audioToggle ? this.els.audioToggle.checked : false, motionReduced: this.els.motionToggle ? this.els.motionToggle.checked : false, }; localStorage.setItem(`casida-meditation-settings-${this.sectionId}`, JSON.stringify(s)); }
  handleSettingChange() { if (this.state === 'idle' || this.state === 'finished') { this.saveSettingsToStorage(); this.reset(false); } }
  handlePatternChange() { const p = this.els.patternSelect.value; this.els.customPatternInputs.dataset.visible = p === 'custom'; this.els.patternInfoContainers.forEach(c => c.dataset.visible = c.dataset.patternInfo === p); this.handleSettingChange(); }
  handleSessionTypeChange() { this.els.sessionValueInput.style.display = this.els.sessionTypeSelect.value === 'endless' ? 'none' : 'block'; this.handleSettingChange(); }
  checkInitialMotionPreference() { const mq = window.matchMedia('(prefers-reduced-motion: reduce)'); if (this.els.motionToggle && !localStorage.getItem(`casida-meditation-settings-${this.sectionId}`)) { this.els.motionToggle.checked = mq.matches; } this.handleMotionToggle(); }
  handleMotionPreferenceChange(matches) { if (this.els.motionToggle) { this.els.motionToggle.checked = matches; this.handleMotionToggle(); } }
  handleMotionToggle() { const isReduced = this.els.motionToggle ? this.els.motionToggle.checked : window.matchMedia('(prefers-reduced-motion: reduce)').matches; this.container.dataset.reducedMotion = isReduced; this.isReducedMotion = isReduced; this.saveSettingsToStorage(); }
  handleKeyPress(e) { if (e.target.closest('input, select, button')) return; if (e.code === 'Space' || e.code === 'Enter') { e.preventDefault(); this.handleStartPause(); } if (e.code === 'KeyR') { e.preventDefault(); this.reset(); } }
  handleStartPause() { if (this.state === 'idle' || this.state === 'finished') this.start(); else if (this.state === 'running') this.pause(); else if (this.state === 'paused') this.resume(); }

  start() {
    this.state = 'running'; this.isFinishing = false; this.currentPattern = this.getCurrentPattern();
    this.currentPhaseIndex = -1; this.currentCycle = 0; this.totalSessionTime = 0;
    this.sessionType = this.els.sessionTypeSelect.value; this.sessionValue = parseInt(this.els.sessionValueInput.value, 10);
    this.sessionTarget = this.sessionType === 'minutes' ? this.sessionValue * 60 : this.sessionValue;
    if (this.settings.enable_prep_countdown) this.runPreparation(); else this.nextPhase();
    this.startSessionTimer(); this.updateUI();
  }

  getCurrentPattern() {
    const key = this.els.patternSelect.value;
    const patterns = {
        '4-7-8': { phases: [{ n: 'inhale', d: 4 }, { n: 'hold', d: 7 }, { n: 'exhale', d: 8 }] },
        '4-4-4-4': { phases: [{ n: 'inhale', d: 4 }, { n: 'hold', d: 4 }, { n: 'exhale', d: 4 }, { n: 'hold_post', d: 4 }] },
        '5-0-5': { phases: [{ n: 'inhale', d: 5 }, { n: 'exhale', d: 5 }] } };
    if (key === 'custom') {
        const p = [ { n: 'inhale', d: parseFloat(this.els.customInhale.value) || 4 }, { n: 'hold', d: parseFloat(this.els.customHold.value) || 0 }, { n: 'exhale', d: parseFloat(this.els.customExhale.value) || 6 }, { n: 'hold_post', d: parseFloat(this.els.customHoldPost.value) || 0 } ].filter(phase => phase.d > 0);
        return { phases: p };
    } return patterns[key];
  }

  runPreparation() {
    let count = 3; this.els.phaseText.textContent = this.settings.prepare_label; this.els.countdown.textContent = count;
    const prepInterval = setInterval(() => { count--; if (count > 0) { this.els.countdown.textContent = count; this.playAudio(); } else { clearInterval(prepInterval); this.nextPhase(); } }, 1000);
  }

  nextPhase() {
    if (this.isFinishing && this.previousPhase?.n === 'exhale') { this.finish(); return; }
    this.currentPhaseIndex++;
    if (this.currentPhaseIndex >= this.currentPattern.phases.length) { this.currentPhaseIndex = 0; this.currentCycle++; if (this.checkSessionEnd()) { this.finish(); return; } }
    this.currentPhase = this.currentPattern.phases[this.currentPhaseIndex];
    this.phaseDuration = this.currentPhase.d * 1000; this.phaseStartTime = performance.now();
    this.updatePhaseVisuals(); this.playAudio();
    if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId);
    this.animationFrameId = requestAnimationFrame((t) => this.tick(t));
  }
  
  updatePhaseVisuals(overrideDuration) {
    const { n, d } = this.currentPhase; const duration = overrideDuration || d;
    this.els.circle.style.transitionDuration = `${duration}s`; this.els.circle.classList.remove('ccm-circle--holding');
    let label = '', scale = 1;
    if (n === 'inhale') { label = this.settings.inhale_label; scale = 1; }
    else if (n === 'hold' || n === 'hold_post') { label = n === 'hold_post' ? this.settings.hold_label_post : this.settings.hold_label; scale = this.previousPhase?.n === 'inhale' ? 1 : 0.5; this.els.circle.classList.add('ccm-circle--holding'); }
    else if (n === 'exhale') { label = this.settings.exhale_label; scale = 0.5; }
    this.els.phaseText.textContent = label;
    if (this.isReducedMotion) { this.els.circle.style.transform = `scale(0.75)`; } else { this.els.circle.style.transform = `scale(${scale})`; }
    this.previousPhase = this.currentPhase;
  }
  
  tick(timestamp) {
    if (this.state !== 'running') return;
    const remaining = this.phaseDuration - (timestamp - this.phaseStartTime);
    if (remaining <= 0) { this.nextPhase(); return; }
    const remainingSeconds = Math.ceil(remaining / 1000);
    if (this.els.countdown.textContent != remainingSeconds) { this.els.countdown.textContent = remainingSeconds; this.els.ariaLive.textContent = `${this.els.phaseText.textContent}, ${remainingSeconds} Sekunden`; }
    this.animationFrameId = requestAnimationFrame((t) => this.tick(t));
  }

  pause() {
    if (this.state !== 'running') return;
    this.state = 'paused'; cancelAnimationFrame(this.animationFrameId); this.animationFrameId = null;
    this.pauseTime = performance.now();
    this.els.circle.style.transitionDuration = '0s';
    this.els.circle.style.transform = window.getComputedStyle(this.els.circle).transform;
    this.els.circle.classList.remove('ccm-circle--holding');
    this.stopSessionTimer(); this.updateUI();
  }
  resume() {
    if (this.state !== 'paused') return;
    this.state = 'running';
    this.phaseStartTime += performance.now() - this.pauseTime;
    const remainingDuration = this.phaseDuration - (performance.now() - this.phaseStartTime);
    this.updatePhaseVisuals(remainingDuration / 1000);
    this.animationFrameId = requestAnimationFrame((t) => this.tick(t));
    if(this.currentPhase.n.includes('hold')) this.els.circle.classList.add('ccm-circle--holding');
    this.startSessionTimer(); this.updateUI();
  }
  reset(fullReset = true) {
    this.state = 'idle'; this.isFinishing = false;
    if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId); this.animationFrameId = null;
    this.stopSessionTimer(); this.totalSessionTime = 0; this.currentCycle = 0;
    if (fullReset) { localStorage.removeItem(`casida-meditation-settings-${this.sectionId}`); }
    this.els.circle.style.transitionDuration = '1s'; this.els.circle.style.transform = 'scale(0.5)';
    this.els.circle.classList.remove('ccm-circle--holding');
    this.els.phaseText.textContent = ''; this.els.countdown.textContent = ''; this.els.ariaLive.textContent = 'Sitzung zurückgesetzt';
    this.updateUI();
  }
  
  playAudio() { if (this.audioElement && this.els.audioToggle?.checked) { this.audioElement.currentTime = 0; this.audioElement.play().catch(e=>console.error(e)); } }
  checkSessionEnd() { if (this.sessionType === 'cycles') return this.currentCycle >= this.sessionTarget; return false; }
  finish() { this.state = 'finished'; this.isFinishing = false; this.els.phaseText.textContent = this.settings.finished_label; this.els.countdown.textContent = '✓'; this.els.ariaLive.textContent = 'Übung abgeschlossen.'; this.els.circle.classList.remove('ccm-circle--holding'); this.stopSessionTimer(); this.updateUI(); }
  
  startSessionTimer() {
    if ((!this.settings.show_session_timer && this.sessionType !== 'minutes') && !this.settings.show_cycle_counter) return;
    this.sessionTimerInterval = setInterval(() => {
        if(this.state === 'running') {
            this.totalSessionTime++;
            if (this.sessionType === 'minutes' && this.totalSessionTime >= this.sessionTarget && !this.isFinishing) {
              this.isFinishing = true;
            }
        }
        if(this.settings.show_session_timer) this.updateTimersDisplay();
    }, 1000);
  }
  stopSessionTimer() { clearInterval(this.sessionTimerInterval); this.sessionTimerInterval = null; }
  updateTimersDisplay() { if (this.els.sessionTimer) { const mins = Math.floor(this.totalSessionTime / 60).toString().padStart(2, '0'); const secs = (this.totalSessionTime % 60).toString().padStart(2, '0'); this.els.sessionTimer.textContent = `${mins}:${secs}`; } if (this.els.cycleCounter) { const target = this.sessionType === 'cycles' ? this.sessionTarget : '∞'; this.els.cycleCounter.textContent = `${this.currentCycle} / ${target}`; } }
  updateUI() { this.els.startButton.dataset.state = this.state; this.els.resetButton.disabled = this.state === 'idle' || this.state === 'finished'; const controlsDisabled = this.state === 'running' || this.state === 'paused'; [this.els.patternSelect, this.els.sessionTypeSelect, this.els.sessionValueInput, this.els.customInhale, this.els.customHold, this.els.customExhale, this.els.customHoldPost].forEach(el => el.disabled = controlsDisabled); switch (this.state) { case 'idle': this.els.startButton.textContent = this.settings.button_start_label; break; case 'running': this.els.startButton.textContent = this.settings.button_pause_label; break; case 'paused': this.els.startButton.textContent = this.settings.button_resume_label; break; case 'finished': this.els.startButton.textContent = this.settings.button_restart_label; break; } this.updateTimersDisplay(); }
  destroy() { this.reset(); }
}

let casidaInstances = {}; function initCasidaSection(container) { const sectionId = container.dataset.sectionId; if (casidaInstances[sectionId]) casidaInstances[sectionId].destroy(); casidaInstances[sectionId] = new CasidaClubMeditation(container); }
document.addEventListener('shopify:section:load', (e) => { const c = e.target.querySelector('[id^="casida-club-meditation-"]'); if (c) initCasidaSection(c); });
document.addEventListener('shopify:section:unload', (e) => { const c = e.target.querySelector('[id^="casida-club-meditation-"]'); if (c) { const sid = c.dataset.sectionId; if (casidaInstances[sid]) { casidaInstances[sid].destroy(); delete casidaInstances[sid]; } } });
document.querySelectorAll('.casida-club-meditation').forEach(c => { if (!c.dataset.initialized) { initCasidaSection(c); c.dataset.initialized = true; } });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casida-diffuser-vergleich"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', function(event) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.cdv__accordion-item').forEach(function(item) {
      if (event.detail && item.dataset.blockId === event.detail.blockId) {
        item.open = true;
        item.scrollIntoView({block: 'nearest'});
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casida-rabattcode-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('casida-rabattcode')) {
    customElements.define('casida-rabattcode', class extends HTMLElement {
      connectedCallback() {
        if (this.crlController) return;
        this.crlController = new AbortController();
        this.crlTimers = new Map();
        this.addEventListener('click', (event) => this.handleClick(event), { signal: this.crlController.signal });
        this.addEventListener('submit', (event) => this.handleNewsletterSubmit(event), { signal: this.crlController.signal });
        const newsletterForm = this.querySelector('.crl-newsletter-form');
        const result = newsletterForm && newsletterForm.querySelector('[data-crl-form-result]');
        if (result) {
          const controller = this.crlController;
          const focusResult = () => window.requestAnimationFrame(() => {
            if (this.isConnected && this.crlController === controller && window.location.hash === '#' + newsletterForm.id) {
              result.focus({ preventScroll: true });
            }
          });
          if (document.readyState === 'complete') focusResult();
          else window.addEventListener('load', focusResult, { once: true, signal: controller.signal });
        }
        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          let element = event.target;
          while (element && element !== this) {
            if (element.tagName === 'DETAILS') element.open = true;
            element = element.parentElement;
          }
        }, { signal: this.crlController.signal });
      }

      disconnectedCallback() {
        if (this.newsletterRequest) this.newsletterRequest.abort();
        this.newsletterRequest = null;
        this.setNewsletterBusy(false);
        if (this.crlController) this.crlController.abort();
        this.crlController = null;
        if (this.crlTimers) {
          this.crlTimers.forEach((timer, button) => {
            window.clearTimeout(timer);
            this.resetCopy(button);
          });
          this.crlTimers.clear();
        }
      }

      track(eventName, offerId) {
        const detail = { event: eventName, offer_id: offerId || null, page_path: window.location.pathname };
        if (this.dataset.trackingEnabled === 'true' && Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
        this.dispatchEvent(new CustomEvent(eventName.replaceAll('_', ':'), { bubbles: true, detail }));
      }

      handleNewsletterSubmit(event) {
        const form = event.target;
        if (!form.matches('.crl-newsletter-form') || form.closest('casida-rabattcode') !== this) return;
        if (this.nativeNewsletterForm === form) return;
        if (this.newsletterRequest) {
          event.preventDefault();
          return;
        }
        this.track('casida_newsletter_submit', null);
        if (event.defaultPrevented || this.dataset.newsletterAjax !== 'true' || event.submitter?.hasAttribute('data-crl-native-submit') || !window.fetch || !window.DOMParser) return;
        const action = new URL(form.action, window.location.href);
        if (action.origin !== window.location.origin || !/^https?:$/.test(action.protocol)) return;
        event.preventDefault();
        this.sendNewsletter(form, action);
      }

      setNewsletterBusy(busy) {
        const form = this.querySelector('.crl-newsletter-form');
        if (!form) return;
        form.classList.toggle('is-submitting', busy);
        form.setAttribute('aria-busy', String(busy));
        const button = form.querySelector('[data-crl-newsletter-submit]');
        const label = form.querySelector('[data-crl-submit-label]');
        const spinner = form.querySelector('[data-crl-submit-spinner]');
        if (button) button.disabled = busy;
        if (spinner) spinner.hidden = !busy;
        if (label) {
          if (!label.dataset.originalLabel) label.dataset.originalLabel = label.textContent;
          label.textContent = busy ? 'Wird gesendet …' : label.dataset.originalLabel;
        }
        form.querySelectorAll('input[type="email"], input[name="contact[name]"]').forEach(input => {
          if (busy) {
            input.dataset.crlReadonly = String(input.readOnly);
            input.readOnly = true;
          } else if (input.dataset.crlReadonly !== undefined) {
            input.readOnly = input.dataset.crlReadonly === 'true';
            delete input.dataset.crlReadonly;
          }
        });
      }

      newsletterFeedback(form, text, error = false, nativeRetry = false) {
        const feedback = form.querySelector('[data-crl-async-message]');
        if (!feedback) return;
        feedback.textContent = text;
        feedback.hidden = false;
        feedback.classList.toggle('crl-form-message--error', error);
        feedback.setAttribute('role', error ? 'alert' : 'status');
        form.querySelector('[data-crl-native-submit]').hidden = !nativeRetry;
        feedback.focus({ preventScroll: true });
      }

      prepareNewsletterCaptcha(form, signal) {
        return new Promise((resolve, reject) => {
          const protect = window.Shopify?.captcha?.protect;
          const ready = () => {
            signal.removeEventListener('abort', aborted);
            const token = form.querySelector('[name="h-captcha-response"]');
            resolve(!token || Boolean(token.value.trim()));
          };
          const aborted = () => reject(new DOMException('Aborted', 'AbortError'));
          if (signal.aborted) { aborted(); return; }
          signal.addEventListener('abort', aborted, { once: true });
          if (typeof protect !== 'function') { ready(); return; }
          try { window.Shopify.captcha.protect(form, ready); }
          catch (error) {
            signal.removeEventListener('abort', aborted);
            reject(error);
          }
        });
      }

      async sendNewsletter(form, action) {
        const controller = new AbortController();
        this.newsletterRequest = controller;
        const timeout = window.setTimeout(() => controller.abort(), 20000);
        let nativeFallback = false;
        let requestStarted = false;
        this.setNewsletterBusy(true);
        form.querySelector('[data-crl-async-message]').hidden = true;
        form.querySelector('[data-crl-native-submit]').hidden = true;
        const oldError = form.querySelector('[data-crl-form-result="error"]');
        if (oldError) oldError.hidden = true;
        form.querySelectorAll('[aria-invalid]').forEach(input => {
          input.removeAttribute('aria-invalid');
          input.removeAttribute('aria-describedby');
        });
        try {
          const captchaReady = await this.prepareNewsletterCaptcha(form, controller.signal);
          if (controller.signal.aborted || !this.isConnected) return;
          if (!captchaReady) { nativeFallback = true; return; }
          const data = new URLSearchParams();
          new FormData(form).forEach((value, key) => { if (typeof value === 'string') data.append(key, value); });
          const returnTo = new URL(window.location.href);
          returnTo.searchParams.delete('customer_posted');
          returnTo.searchParams.delete('form_type');
          returnTo.hash = form.id;
          data.set('return_to', returnTo.pathname + returnTo.search + returnTo.hash);
          requestStarted = true;
          const response = await fetch(action.href, {
            method: 'POST',
            body: data,
            headers: { Accept: 'text/html' },
            mode: 'same-origin',
            credentials: 'same-origin',
            redirect: 'follow',
            cache: 'no-store',
            signal: controller.signal
          });
          if (!this.isConnected || this.newsletterRequest !== controller) return;
          const responseUrl = new URL(response.url);
          if (responseUrl.origin !== window.location.origin) throw new Error('Unexpected response origin');
          if (/(^|\/)challenge(?:\/|$)/.test(responseUrl.pathname)) {
            responseUrl.hash = '';
            window.location.assign(responseUrl.href);
            return;
          }
          if (response.status === 429) {
            this.newsletterFeedback(form, 'Zu viele Anmeldeversuche. Bitte warte einen Moment und versuche es dann erneut.', true);
            return;
          }
          const html = await response.text();
          if (!this.isConnected || this.newsletterRequest !== controller) return;
          const documentResponse = new DOMParser().parseFromString(html, 'text/html');
          const responseForm = documentResponse.getElementById(form.id);
          const result = responseForm?.querySelector('[data-crl-form-result]');
          const message = result?.textContent.trim();
          if (response.ok && result?.dataset.crlFormResult === 'success' && message) {
            form.querySelector('[data-crl-form-content]').hidden = true;
            this.newsletterFeedback(form, message);
            this.track('casida_newsletter_success', null);
          } else if (result?.dataset.crlFormResult === 'error' && message) {
            this.newsletterFeedback(form, message, true);
            responseForm.querySelectorAll('input[aria-invalid="true"]').forEach(input => {
              const field = form.elements.namedItem(input.name);
              if (field instanceof HTMLInputElement) {
                field.setAttribute('aria-invalid', 'true');
                field.setAttribute('aria-describedby', form.querySelector('[data-crl-async-message]').id);
              }
            });
          } else {
            this.newsletterFeedback(form, 'Die Anmeldung konnte nicht bestätigt werden. Bitte prüfe dein E-Mail-Postfach, bevor du die Anmeldung erneut sendest.', true, true);
          }
        } catch (_) {
          if (!this.isConnected || this.newsletterRequest !== controller) return;
          const message = requestStarted
            ? 'Die Rückmeldung ist ausgeblieben. Bitte prüfe dein E-Mail-Postfach, bevor du die Anmeldung erneut sendest.'
            : 'Die Anmeldung konnte noch nicht gesendet werden. Bitte setze die Anmeldung über den folgenden Button fort.';
          this.newsletterFeedback(form, message, true, true);
        } finally {
          window.clearTimeout(timeout);
          if (this.newsletterRequest === controller) {
            this.newsletterRequest = null;
            this.setNewsletterBusy(false);
            if (nativeFallback && this.isConnected) {
              const lifecycle = this.crlController;
              // Das laufende Submit-Ereignis muss vor der nativen Fortsetzung abgeschlossen sein.
              window.setTimeout(() => {
                if (!this.isConnected || this.crlController !== lifecycle || this.newsletterRequest) return;
                this.nativeNewsletterForm = form;
                try { form.requestSubmit(); }
                finally { this.nativeNewsletterForm = null; }
              }, 0);
            }
          }
        }
      }

      handleClick(event) {
        const control = event.target.closest('[data-crl-copy], [data-crl-apply], [data-crl-newsletter-link], [data-crl-newsletter-submit]');
        if (!control || control.closest('casida-rabattcode') !== this) return;
        if (control.hasAttribute('data-crl-copy')) {
          this.copyCode(control);
        } else if (control.hasAttribute('data-crl-apply')) {
          this.track('casida_coupon_apply', control.dataset.offerId);
        } else {
          this.track('casida_newsletter_click', null);
          const href = control.getAttribute('href');
          if (!href || !href.startsWith('#') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          let target;
          try { target = document.getElementById(decodeURIComponent(href.slice(1))); } catch (_) { target = null; }
          if (!target) return;
          let ancestor = target;
          while (ancestor) {
            if (ancestor.tagName === 'DETAILS') ancestor.open = true;
            ancestor = ancestor.parentElement;
          }
          const hadTabindex = target.hasAttribute('tabindex');
          if (!hadTabindex) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          if (!hadTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
      }

      fallbackCopy(text) {
        const previousFocus = document.activeElement;
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.readOnly = true;
        textarea.style.cssText = 'position:fixed;top:-9999px;left:0;font-size:16px;';
        this.appendChild(textarea);
        let copied = false;
        try {
          textarea.select();
          copied = document.execCommand('copy');
        } catch (_) {
          copied = false;
        } finally {
          textarea.remove();
          if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
        }
        return copied;
      }

      resetCopy(button) {
        button.classList.remove('is-copied');
        const label = button.querySelector('[data-crl-copy-label]');
        if (label && button.dataset.originalLabel !== undefined) label.textContent = button.dataset.originalLabel;
        button.setAttribute('aria-label', 'Gutscheincode ' + button.dataset.code + ' kopieren');
      }

      async copyCode(button) {
        const code = button.dataset.code;
        const controller = this.crlController;
        if (!code || button.dataset.copyPending === 'true') return;
        window.clearTimeout(this.crlTimers.get(button));
        this.crlTimers.delete(button);
        this.resetCopy(button);
        button.dataset.copyPending = 'true';
        let copied = false;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(code);
            copied = true;
          }
        } catch (_) {
          copied = false;
        }
        if (!this.isConnected || this.crlController !== controller) {
          delete button.dataset.copyPending;
          return;
        }
        if (!copied) copied = this.fallbackCopy(code);
        delete button.dataset.copyPending;
        const live = this.querySelector('[data-crl-live]');
        if (!copied) {
          if (live) live.textContent = 'Bitte markiere und kopiere den Gutscheincode ' + code + ' manuell.';
          const label = button.querySelector('[data-crl-copy-label]');
          if (label) {
            button.dataset.originalLabel = button.dataset.originalLabel || label.textContent;
            label.textContent = 'Manuell kopieren';
          }
          return;
        }
        const label = button.querySelector('[data-crl-copy-label]');
        if (label) {
          button.dataset.originalLabel = button.dataset.originalLabel || label.textContent;
          label.textContent = this.dataset.copiedLabel;
        }
        button.classList.add('is-copied');
        button.setAttribute('aria-label', 'Gutscheincode ' + code + ' kopiert');
        if (live) live.textContent = 'Gutscheincode ' + code + ' wurde kopiert.';
        this.track('casida_coupon_copy', button.dataset.offerId);
        window.clearTimeout(this.crlTimers.get(button));
        this.crlTimers.set(button, window.setTimeout(() => {
          this.resetCopy(button);
          this.crlTimers.delete(button);
        }, 2000));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casida-wunsch-badeset"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('casida-bath-set')) {
    customElements.define('casida-bath-set', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const link = event.target.closest('a[href^="#"]');
          if (!link || !this.contains(link)) return;
          const id = link.getAttribute('href').slice(1);
          const target = document.getElementById(id);
          if (!target || !this.contains(target)) return;
          event.preventDefault();
          event.stopPropagation();
          target.focus({ preventScroll: true });
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }, { capture: true, signal: this.controller.signal });
        this.widget = this.querySelector('[data-bath-reviews]');
        if (!this.widget || this.widget.dataset.ready === 'true') return;
        const token = {};
        this.reviewToken = token;
        const initialize = () => {
          if (!this.isConnected || this.reviewToken !== token || this.widget.dataset.ready === 'true' || typeof window.ReviewsWidget !== 'function') return;
          const styles = getComputedStyle(this);
          try {
            new window.ReviewsWidget('#' + this.widget.id, {
              store: this.widget.dataset.store,
              widget: 'polaris',
              options: {
                types: 'store_review', lang: 'de', layout: '', per_page: 2,
                store_review: { hide_if_no_results: true, enable_pagination: true },
                header: { enable_summary: true, enable_ratings: true, enable_attributes: false, enable_image_gallery: false, enable_percent_recommended: true, enable_write_review: false, enable_ask_question: false, enable_sub_header: false, rating_decimal_places: 1 },
                filtering: { enable: false, enable_text_search: false, enable_sorting: false, enable_product_filter: false, enable_media_filter: false, enable_overall_rating_filter: false, enable_language_filter: false, enable_ratings_filters: false, enable_attributes_filters: false },
                reviews: { enable_avatar: false, enable_reviewer_name: true, enable_reviewer_address: false, enable_verified_badge: true, enable_subscriber_badge: true, enable_reviewer_recommends: true, enable_attributes: false, enable_product_name: false, enable_review_title: false, enable_replies: false, enable_images: false, enable_ratings: false, enable_share: false, enable_helpful_vote: false, enable_helpful_display: false, enable_report: false, enable_date: true, enable_third_party_source: false }
              },
              translations: { 'Verified Customer': 'Verifizierter Käufer' },
              styles: {
                '--base-font-size': '15px',
                '--common-star-color': styles.getPropertyValue('--bath-stars').trim(),
                '--heading-text-color': styles.getPropertyValue('--bath-heading').trim(),
                '--heading-text-font-family': 'inherit',
                '--heading-text-font-weight': '600',
                '--body-text-color': styles.getPropertyValue('--bath-text').trim(),
                '--body-text-font-family': 'inherit',
                '--body-text-line-height': '1.6',
                '--badge-icon-color': styles.getPropertyValue('--bath-dark').trim(),
                '--badge-text-color': styles.getPropertyValue('--bath-dark').trim()
              }
            });
            this.widget.dataset.ready = 'true';
          } catch (error) {
            this.widget.dataset.ready = 'false';
          }
        };
        if (typeof window.ReviewsWidget === 'function') {
          initialize();
          return;
        }
        let script = document.querySelector('script[src*="widget.reviews.io/polaris/build.js"], script[src*="widget.reviews.co.uk/polaris/build.js"]');
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://widget.reviews.io/polaris/build.js';
          script.async = true;
          document.head.appendChild(script);
        }
        script.addEventListener('load', initialize, { once: true, signal: this.controller.signal });
        let attempts = 0;
        this.timer = setInterval(() => {
          initialize();
          if (++attempts >= 40 || this.widget.dataset.ready === 'true') clearInterval(this.timer);
        }, 250);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.reviewToken = null;
        clearInterval(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herbst-2026-links"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sync = () => {
    document.querySelectorAll('[data-herbst-links]').forEach(root => {
      const nav = root.querySelector('nav');
      if (!nav) return;
      let visible = false;
      nav.querySelectorAll('[data-herbst-anchor]').forEach(link => {
        const target = document.getElementById(link.dataset.herbstAnchor);
        const show = !!target && target.hasAttribute('data-herbst-products');
        link.hidden = !show;
        if (show) visible = true;
      });
      nav.hidden = !visible;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(sync));
  document.addEventListener('shopify:section:reorder', sync);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rossmann-info"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rossmann-info')) {
    customElements.define('rossmann-info', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.ready = false;
      }
      initInstagram(signal) {
        const box = this.querySelector('[data-ri-insta]');
        if (!box) return;
        const gate = box.querySelector('[data-ri-insta-gate]');
        box.hidden = false;
        const loadButton = box.querySelector('[data-ri-insta-load]');
        const show = () => {
          if (this.instaFrame) return;
          let url;
          try { url = new URL(box.dataset.src); } catch (error) { return; }
          if (url.origin !== 'https://www.instagram.com') return;
          const frame = document.createElement('iframe');
          frame.className = 'ri__insta-frame';
          frame.src = url.href;
          frame.title = box.dataset.title || 'Instagram-Beitrag';
          frame.loading = 'lazy';
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.setAttribute('scrolling', 'no');
          frame.setAttribute('allowtransparency', 'true');
          const sandbox = ['allow-scripts', 'allow-same-origin', 'allow-presentation'];
          if (box.dataset.blockLinks !== 'true') sandbox.push('allow-popups', 'allow-popups-to-escape-sandbox');
          frame.setAttribute('sandbox', sandbox.join(' '));
          gate.hidden = true;
          box.append(frame);
          this.instaFrame = frame;
        };
        window.addEventListener('message', event => {
          if (event.origin !== 'https://www.instagram.com' || !this.instaFrame || event.source !== this.instaFrame.contentWindow) return;
          let data = event.data;
          if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch (error) { return; }
          }
          const height = Number(data?.details?.height);
          if (data?.type === 'MEASURE' && Number.isFinite(height) && height > 0) this.instaFrame.style.height = `${Math.ceil(height)}px`;
        }, { signal });
        if (box.dataset.consent === 'true') {
          loadButton.hidden = false;
          loadButton.addEventListener('click', show, { signal });
        } else {
          show();
        }
      }
      initProducts(signal) {
        const box = this.querySelector('[data-ri-products]');
        if (!box) return;
        const list = box.querySelector('[data-ri-products-list]');
        const nav = box.querySelector('[data-ri-products-nav]');
        const prev = box.querySelector('[data-ri-products-prev]');
        const next = box.querySelector('[data-ri-products-next]');
        const update = () => {
          const max = list.scrollWidth - list.clientWidth;
          nav.hidden = max <= 2;
          prev.disabled = list.scrollLeft <= 2;
          next.disabled = list.scrollLeft >= max - 2;
        };
        const step = direction => {
          const first = list.firstElementChild;
          const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
          const width = first ? first.getBoundingClientRect().width + gap : list.clientWidth;
          const perPage = Math.max(1, Math.floor(list.clientWidth / width));
          list.scrollBy({ left: direction * width * perPage, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        prev.addEventListener('click', () => step(-1), { signal });
        next.addEventListener('click', () => step(1), { signal });
        list.addEventListener('scroll', update, { passive: true, signal });
        window.addEventListener('resize', update, { passive: true, signal });
        update();
        requestAnimationFrame(update);
        this.initReviews(box);
        this.initCart(box, signal);
      }
      initCart(box, signal) {
        box.addEventListener('submit', async event => {
          const form = event.target.closest?.('[data-ri-atc]');
          if (!form) return;
          event.preventDefault();
          if (form.dataset.state === 'added') { window.location.href = form.dataset.cartUrl || '/cart'; return; }
          const button = form.querySelector('[data-ri-atc-button]');
          const label = form.querySelector('[data-ri-atc-label]');
          if (button.getAttribute('aria-busy') === 'true') return;
          const original = form.dataset.label || label.textContent;
          form.dataset.label = original;
          button.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: Number(form.elements.id.value), quantity: 1 })
            });
            if (response.status === 422) {
              button.classList.add('is-error');
              label.textContent = form.dataset.error;
              setTimeout(() => { button.classList.remove('is-error'); label.textContent = original; }, 2600);
              return;
            }
            if (!response.ok) throw new Error('Cart');
            if (form.dataset.after === 'cart') { window.location.href = form.dataset.cartUrl || '/cart'; return; }
            button.classList.add('is-added');
            label.textContent = form.dataset.added;
            form.dataset.state = 'added';
            setTimeout(() => { label.textContent = form.dataset.cartLabel || form.dataset.added; }, 1800);
            try {
              const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart }, bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart }, bubbles: true }));
            } catch (error) { /* Hinweis am Button genuegt */ }
          } catch (error) {
            form.submit();
          } finally {
            button.removeAttribute('aria-busy');
          }
        }, { signal });
      }
      initReviews(box) {
        /* REVIEWS.io: Das Rating-Snippet fuellt jedes .ruk_rating_snippet-Element mit Sternen und Anzahl.
           Ist das Widget (window.ratingSnippet) schon da, wird es direkt gestartet. Laedt das Theme es gerade erst,
           wird kurz gewartet. Sonst laedt die Seite das Skript selbst (abschaltbar), mit der Store-ID aus den Einstellungen. */
        const store = box.dataset.reviewsStore;
        if (!store || !box.querySelector('.ruk_rating_snippet')) return;
        const run = () => {
          if (typeof window.ratingSnippet !== 'function') return false;
          window.ratingSnippet('ruk_rating_snippet', { store, color: box.dataset.reviewsColor || '#ff8105', linebreak: false, text: '' });
          return true;
        };
        if (run()) return;
        const loading = document.querySelector('script[src*="reviews.co.uk"], script[src*="reviews.io"]');
        if (!loading && box.dataset.reviewsLoad === 'true') {
          const script = document.createElement('script');
          script.src = 'https://widget.reviews.co.uk/rating-snippet/dist.js';
          script.async = true;
          document.head.append(script);
        }
        let tries = 0;
        const timer = setInterval(() => { if (run() || ++tries > 30) clearInterval(timer); }, 300);
      }
      init() {
        if (this.ready || !this.isConnected) return;
        this.ready = true;
        this.controller = new AbortController();
        this.initInstagram(this.controller.signal);
        this.initProducts(this.controller.signal);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-listicle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('test-listicle')) {
  customElements.define('test-listicle', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('[data-gallery]');
      this.thumbs = [...this.querySelectorAll('[data-slide]')];
      this.bundles = [...this.querySelectorAll('[data-bundle]')];
      this.buy = this.querySelector('[data-buy]');
      this.calculator = this.querySelector('[data-calculator]');
      this.weight = this.querySelector('[data-weight]');
      this.addEventListener('click', event => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const thumbnail = target.closest('[data-slide]');
        if (thumbnail) this.showSlide(Number(thumbnail.dataset.slide));
        const step = target.closest('[data-weight-step]');
        if (step && this.weight) this.setWeight(Number(this.weight.value) + Number(step.dataset.weightStep));
        const link = target.closest('a');
        if (!link) return;
        if (link.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        const href = link.getAttribute('href');
        if (!href?.startsWith('#')) return;
        const anchor = document.getElementById(href.slice(1));
        if (anchor && this.contains(anchor)) {
          event.preventDefault();
          anchor.scrollIntoView({ behavior: this.motion(), block: 'start' });
          anchor.setAttribute('tabindex', '-1');
          anchor.focus({ preventScroll: true });
        }
      }, { signal });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-bundle]')) this.selectBundle(event.target);
        if (event.target.matches('[data-weight]')) this.setWeight(Number(event.target.value));
      }, { signal });
      this.weight?.addEventListener('input', () => {
        if (this.weight.value !== '' && Number.isFinite(Number(this.weight.value))) this.updateDosage(Number(this.weight.value));
      }, { signal });
      this.weight?.addEventListener('blur', () => this.setWeight(Number(this.weight.value)), { signal });
      this.track?.addEventListener('scroll', () => {
        const width = this.track.clientWidth;
        if (width) this.markSlide(Math.round(this.track.scrollLeft / width));
      }, { signal, passive: true });
      this.track?.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.showSlide(index + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const block = [...this.querySelectorAll('[data-block-id]')].find(el => el.dataset.blockId === event.detail?.blockId);
        if (!block) return;
        if (block.tagName === 'DETAILS') block.open = true;
        const radio = block.querySelector('[data-bundle]');
        if (radio) { radio.checked = true; this.selectBundle(radio); }
      }, { signal });
      this.selectBundle(this.bundles.find(input => input.checked));
      if (this.weight) this.setWeight(Number(this.weight.value));
    }
    disconnectedCallback() { this.controller?.abort(); }
    motion() { return this.classList.contains('hrlp--motion') && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'; }
    showSlide(index) {
      if (!this.track) return;
      const next = Math.max(0, Math.min(this.thumbs.length - 1, index));
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: this.motion() });
      this.markSlide(next);
    }
    markSlide(index) {
      this.thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('hrlp-offer__carousel-thumb--active', i === index);
        thumb.setAttribute('aria-pressed', String(i === index));
      });
    }
    selectBundle(input) {
      if (!input) return;
      this.bundles.forEach(radio => radio.closest('.hrlp-offer__qty-option').classList.toggle('hrlp-offer__qty-option--selected', radio === input));
      if (this.buy) {
        if (input.dataset.url) { this.buy.setAttribute('href', input.dataset.url); this.buy.removeAttribute('aria-disabled'); }
        else { this.buy.removeAttribute('href'); this.buy.setAttribute('aria-disabled', 'true'); }
      }
      const note = this.querySelector('[data-shipping-note]');
      if (note) note.textContent = input.dataset.shipping || '';
    }
    setWeight(value) {
      if (!this.weight) return;
      const maximum = Number(this.weight.max) || 80;
      const initial = Number(this.weight.defaultValue) || 8;
      const valid = Number.isFinite(value) && value > 0 ? value : initial;
      const weight = Math.max(1, Math.min(maximum, Math.round(valid)));
      this.weight.value = String(weight);
      this.updateDosage(weight);
    }
    updateDosage(value) {
      if (!this.calculator || !this.weight) return;
      const weight = Math.max(1, Math.min(Number(this.weight.max) || 80, Math.round(value)));
      const rate = Number(this.calculator.dataset.rate);
      const maximum = Number(this.calculator.dataset.maxDose);
      const pack = Number(this.calculator.dataset.pack);
      if (![rate, maximum, pack].every(n => Number.isFinite(n) && n > 0)) return;
      const daily = Math.min(maximum, weight * rate);
      const dose = Math.min(maximum, Math.ceil(daily * 2) / 2);
      const weeks = packs => Math.max(1, Math.round(pack * packs / daily / 7));
      const format = number => number.toLocaleString('de-DE', { maximumFractionDigits: 2 });
      const values = { weight: format(weight), dose: format(dose), pack: format(pack), weeks: format(weeks(1)) };
      const result = this.querySelector('[data-dose-result]');
      if (result) {
        const pattern = this.calculator.dataset.resultPattern || '';
        const parts = pattern.split(/(\{(?:weight|dose|pack|weeks)\})/g);
        result.replaceChildren(...parts.map(part => {
          const key = part.slice(1, -1);
          if (!Object.hasOwn(values, key)) return document.createTextNode(part);
          if (key === 'dose' || key === 'weeks') { const strong = document.createElement('strong'); strong.textContent = values[key]; return strong; }
          return document.createTextNode(values[key]);
        }));
      }
      this.bundles.forEach(input => {
        const duration = input.closest('.hrlp-offer__qty-option').querySelector('[data-duration]');
        if (duration) duration.textContent = (this.calculator.dataset.durationPattern || '').replaceAll('{weeks}', format(weeks(Number(input.dataset.packs) || 1)));
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
